import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kart-prep-page',
  templateUrl: './kart-prep-page.component.html',
  styleUrls: ['./kart-prep-page.component.scss']
})
export class KartPrepPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
